import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { ArrowRight, Moon, Sun } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { HeroSection } from "../components/landing/HeroSection";
import { ProcessSection } from "../components/landing/ProcessSection";
import { FeaturesSection } from "../components/landing/FeaturesSection";
import { CategoriesSection } from "../components/landing/CategoriesSection";
import { CTASection } from "../components/landing/CTASection";

const STATS = [
  { value: "73%+", label: "Avg. Probability" },
  { value: "Daily", label: "New Opportunities" },
  { value: "4", label: "Regions Covered" },
  { value: "8+", label: "Asset Categories" }
];

export default function LandingPage() {
  const navigate = useNavigate();
  const { toggleTheme, isDark } = useTheme();

  return (
    <div className={`min-h-screen overflow-hidden transition-colors duration-300 ${isDark ? 'bg-[#0a0a14] text-white' : 'bg-white text-gray-900'}`}>
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b transition-colors ${isDark ? 'bg-[#0a0a14]/80 border-white/5' : 'bg-white/80 border-gray-200'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <img 
                src={isDark ? "/logo-dark.png" : "/logo-light.png"} 
                alt="MyQairo" 
                className="h-12 w-auto"
              />
            </div>
            
            <div className="flex items-center gap-4">
              <button
                onClick={toggleTheme}
                className={`p-2 rounded-full transition-colors ${isDark ? 'hover:bg-white/10' : 'hover:bg-gray-100'}`}
                data-testid="theme-toggle"
              >
                {isDark ? (
                  <Sun size={20} className="text-yellow-400" />
                ) : (
                  <Moon size={20} className="text-purple-600" />
                )}
              </button>
              
              <Button
                onClick={() => navigate("/dashboard")}
                className="bg-purple-600 hover:bg-purple-700 text-white rounded-full px-6"
                data-testid="nav-enter-btn"
              >
                Enter Platform
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </nav>

      <HeroSection isDark={isDark} stats={STATS} />
      <ProcessSection isDark={isDark} />
      <FeaturesSection isDark={isDark} />
      <CategoriesSection isDark={isDark} />
      <CTASection isDark={isDark} />

      {/* Footer */}
      <footer className={`py-12 px-4 sm:px-6 lg:px-8 border-t ${isDark ? 'border-white/5' : 'border-gray-200'}`}>
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-3">
              <img 
                src={isDark ? "/logo-dark.png" : "/logo-light.png"}
                alt="MyQairo" 
                className="h-10 w-auto"
              />
            </div>
            
            <p className={`text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
              &copy; 2026 MyQairo. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
